import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import LoadingSpinner from "./loading_spinner";

class AddOptionOrSelectFromRadio extends React.Component {
  render () {
    const classes = classNames({
      "overlay-with-form-in-middle": true,
      hidden: this.props.hidden
    });

    const checked = (e) => e.value === this.props.selectedOptionValue;

    const options = ([this.props.newOption].concat(this.props.options)).map((e) => {
      let textInput;

      if (e.value == this.props.newValue) {
        textInput = <div className="text-input" key={e.value}>
                      <input type="text"
                             className="form-control string required"
                             value={this.props.textValue}
                             placeholder={this.props.placeholder}
                             disabled={!checked(e)}
                             onChange={this.props.textChange}
                      />
                    </div>;
      }

      const input = <div className="form-group" key={e.value}>
                      <div className="radio">
                        <label>
                          <input onChange={this.props.radioSelect}
                                 type="radio"
                                 value={e.value}
                                 checked={checked(e)}
                          />
                          {e.label}
                        </label>
                      </div>
                      {textInput}
                    </div>;

      return input;
    });

    const submitDisabled = this.props.loadingOptions || this.props.newOptionNeedsName;
    const onSubmit = submitDisabled ? () => {} : this.props.onAdd;
    const addText = this.props.addText || "Add";

    return (
      <div className={classes}>
        <div className="form">
          <h4>{this.props.title}</h4>
          <div className="options">
            {options}

            <LoadingSpinner show={this.props.loadingOptions} />
          </div>
          <div className="row controls">
            <div className="col-6">
              <a className="btn btn-block btn-primary" disabled={submitDisabled} onClick={onSubmit}>{addText}</a>
            </div>

            <div className="col-6">
              <a className="btn btn-block btn-default" onClick={this.props.onCancel}>Cancel</a>
            </div>
          </div>

          <LoadingSpinner show={this.props.showSpinner} message="Saving" />
        </div>
      </div>
    );
  }
}

const valueType = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
const optionShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: valueType.isRequired
});

AddOptionOrSelectFromRadio.propTypes = {
  hidden: PropTypes.bool.isRequired,
  selectedOptionValue: valueType.isRequired,
  options: PropTypes.arrayOf(optionShape),
  onAdd: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  textValue: PropTypes.string.isRequired,
  radioSelect: PropTypes.func.isRequired,
  textChange: PropTypes.func.isRequired,
  newOption: optionShape,
  loadingOptions: PropTypes.bool.isRequired,
  showSpinner: PropTypes.bool.isRequired,
  newOptionNeedsName: PropTypes.bool.isRequired,
  newValue: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  addText: PropTypes.string
};

export default AddOptionOrSelectFromRadio;
